module.exports = __webpack_public_path__ + "img/89eee19.png";